<div class="legend shadow-lg rounded-2 border p-2 px-3">
  <ng-Content></ng-Content>
</div>
